import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { EMAIL_REGEX } from 'src/constants';
import { RootState } from 'src/redux/reducers';

interface InputBoxprops {
  handleChange: (e?: Record<string, any>) => void;
  onKeyDown?: (e: React.KeyboardEvent<any>) => void;
  customeWidth?: string;
  email: string;
}

const InputEmail = ({
  handleChange,
  email,
  customeWidth,
  onKeyDown,
}: InputBoxprops): ReactElement => {
  const Auth = useSelector((state: RootState) => {
    return state.auth;
  });
  const isError = email?.match(EMAIL_REGEX) || email === '' ? false : true;
  const [isTouched, setIsTouched] = useState(false);
  return (
    <div className={`${customeWidth ? customeWidth : 'w-10/12'}`}>
      <div className="border rounded-lg bg-white focus:outline-none focus:border-blue flex flex-row">
        <input
          className="h-flagh w-full px-4 rounded-lg text-700 leading-tight focus:outline-none focus:border-blue"
          onChange={handleChange}
          onKeyDown={onKeyDown}
          value={email}
          type="email"
          placeholder={'Enter email'}
          onBlur={(): void => setIsTouched(true)}
        />
      </div>
      {isError && isTouched && <p className="text-red-600 text-sm text-left pt-2">Invalid email</p>}
    </div>
  );
};

export default InputEmail;
